import { useAppSelector } from "app/hooks"
import useNativeAppPaywallUrl from "features/notification/useNativeAppPaywallUrl"
import React from "react"
import { checkHasScanBarcodeScanningEntitlement } from "utils"
import { isInWebView } from "utils/webViewDetection"

const BarcodePaywallTrigerer = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const userPlan = useAppSelector((state) => state.payment.userPlan)
  const getUserPlanLoading = useAppSelector(
    (state) => state.payment.getUserPlanLoading,
  )

  const hasBarcodeScanningEntitlement = checkHasScanBarcodeScanningEntitlement(
    userPlan?.entitlements ?? [],
  )

  const nativeAppPaywallUrl = useNativeAppPaywallUrl()

  if (isInWebView() && !hasBarcodeScanningEntitlement && !getUserPlanLoading) {
    return (
      <a
        href={nativeAppPaywallUrl}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {children}
      </a>
    )
  }

  return <>{children}</>
}

export default BarcodePaywallTrigerer
